import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule }   from '@angular/forms';

import { AppRoutingModule } from './app.routing';

import { AppComponent } from './app.component';

import {
  BannerComponent,
  FooterComponent,
  NavComponent,
  NavmobileComponent,
  TitleComponent
} from './shared';

import {
  AboutComponent,
  ContactComponent,
  FormComponent,
  HomeComponent,
  NotFoundComponent,
  SolutionsComponent,
  SolutionIconComponent,
  SolutionDescriptionComponent
} from './pages';

import {
  SwiperModule,
  SWIPER_CONFIG,
  SwiperConfigInterface
} from 'ngx-swiper-wrapper';

import { LeafletModule } from '@asymmetrik/ngx-leaflet';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};

@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    HomeComponent,
    ContactComponent,
    FormComponent,
    SolutionsComponent,
    NotFoundComponent,
    FooterComponent,
    BannerComponent,
    TitleComponent,
    NavmobileComponent,
    AboutComponent,
    SolutionIconComponent,
    SolutionDescriptionComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SwiperModule,
    LeafletModule.forRoot()
  ],
  providers: [
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    },
    Title
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  getState(outlet) {
    return outlet.activatedRouteData.state;
  }
}
